import React from 'react';
import cn from 'classnames';
import styles from './style.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { useTranslation } from 'react-i18next';

const variants = {
  chernInt: { param: 'chernInt', key: 'chernInt', text: i18n.t('components.header.filtersBar.filters.decoration.chernInt') },
  chistInt: { param: 'chistInt', key: 'chistInt', text: i18n.t('components.header.filtersBar.filters.decoration.chistInt'), event: 'Web_Filters_Finishing' },
  predChistInt: { param: 'predChistInt', key: 'predChistInt', text: i18n.t('components.header.filtersBar.filters.decoration.predChistInt') },
  remInt: { param: 'remInt', key: 'remInt', text: i18n.t('components.header.filtersBar.filters.decoration.remInt'), event: 'Web_Filters_Repair' }
  // 'chastRemInt': { param: 'chastRemInt', key: 'chastRemInt', text: i18n.t('components.header.filtersBar.filters.decoration.chastRemInt') }
};

export const parseSearch = (search) => {
  const { interior } = search;
  if (!interior) {
    return { interior: [] };
  }
  const keys = interior.split(',');
  return {
    interior: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { interior: keys } = data;
  if (!keys || !keys.length) {
    return { interior: undefined };
  }

  return {
    interior: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { interior } = data;
  return { interior: interior.length ? interior : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { interior: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.decoration.notSelected');
};

const Decoration = (props) => {
  const { t } = useTranslation();
  const handleClearClick = () => {
    const { dropdownData } = props;
    const data = { interior: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    props.onClearClick && props.onClearClick('interior');
  };

  const handleCheckboxClick = (key, add) => {
    const { search, dropdownData, eventData } = props;
    const { interior: keys } = parseSearch(search);
    const interior = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (interior.includes(key) !== add) {
      if (add) {
        interior.push(key);
      } else {
        interior.splice(interior.indexOf(key), 1);
      }
    }

    const data = { interior };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  };

  const checkbox = (key) => {
    const { search, additional } = props;
    const { interior } = parseSearch(search);

    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={interior.includes(variant.key)}
        handle={value => handleCheckboxClick(variant.key, value)}
        additional={additional}
        text={variant.text}
      />
    );
  };

  const { className, additional, search, isCottegePage } = props;
  const { interior } = parseSearch(search);
  const name = isCottegePage ? t('components.header.filtersBar.filters.decoration.title') : t('components.header.filtersBar.filters.decoration.titleFull');

  return (
    <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
      <p className={styles.Title}>
        {name}
        {!additional ? (
            !!interior.length &&
            <Button className={styles.Button} onClick={handleClearClick}>
              {t('components.header.filtersBar.filters.decoration.clear')}
            </Button>
          ) : (null)}
      </p>
      <div className={styles.Checkboxes}>
        <div className={styles.FirstColumn}>
          {checkbox('chistInt')}
        </div>
        <div className={styles.SecondColumn}>
          {checkbox('remInt')}
        </div>
      </div>
      {additional ? (
        <div className={styles.ButtonWrap}>
          {!!interior.length &&
          <Button className={styles.Button} onClick={handleClearClick}>
            {t('components.header.filtersBar.filters.decoration.clear')}
          </Button>}
        </div>
        ) : (null)}
    </div>
  );
};

export default Decoration;



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Decoration/Decoration.js